import React from 'react';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const SuccessMessage = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      USER_AUTHENTICATION: {
        UPDATE_PASSWORD_SCHEMA:{
          SUCCESS_MESSAGE,
          NOTE
        }
      }
    }
  } = localizedStrings;
  return (
    <>
      <div
        id="email_sent"
        className="informational_message"
        style={{ marginTop: 15 }}
      >
        <span
          className="frg-icon icon-warning-inverted"
          style={{
            fontSize: 14,
            color: '#66cc00',
            marginRight: 5
          }}
        />
        <span className="frg-body-font-14px">
          <b>{NOTE}</b>: {SUCCESS_MESSAGE}
        </span>
      </div>
    </>
  );
};

export default SuccessMessage;
